























import { Component, Vue } from 'vue-property-decorator';
import SearchCompanyItem from '@/views/SearchCompanyItem.vue';
import search from '@/store/modules/search';
import user from '@/store/modules/user';

@Component({
    components: {SearchCompany: SearchCompanyItem},
})
export default class Search extends Vue {
    async updateCompany(OrgNr: string) {
        await user.addCompany(OrgNr);
        this.$router.push({ name: 'overview', params: { OrgNr } });
    }
    get pendingSearch() {
        return search.pending;
    }
    get pendingFetch() {
        return user.fetchingData;
    }
    get result() {
        return search.result;
    }
}
